var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hinava_random_uuid_156715302288600315415204163985944805067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hinava_random_uuid_110061798680548672519264642786855784063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_156364285727334631987594190808200159491",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.5C16.8044 3.5 19.4416 4.592 21.4244 6.57563C23.408 8.5575 24.5 11.1956 24.5 14C24.5 16.8044 23.408 19.4416 21.4244 21.4244C19.4425 23.408 16.8044 24.5 14 24.5C11.1956 24.5 8.55838 23.408 6.57563 21.4244C4.592 19.4425 3.5 16.8044 3.5 14C3.5 11.1956 4.592 8.55838 6.57563 6.57563C8.5575 4.592 11.1956 3.5 14 3.5ZM14 5.14062C9.11487 5.14062 5.14062 9.11487 5.14062 14C5.14062 18.8851 9.11487 22.8594 14 22.8594C18.8851 22.8594 22.8594 18.8851 22.8594 14C22.8594 9.11487 18.8851 5.14062 14 5.14062ZM14.3684 7V13.5336H18.6664V15.1664H12.8336V7H14.3684Z",
    fill: "#D4D4D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeGray);
export default __webpack_public_path__ + "static/media/time-gray.8c31af9b42d1f8fe81c78f1436e06b2e.svg";
export { ForwardRef as ReactComponent };